import heroBg from '@/assets/join/bg.png';
import jobBg from '@/assets/join/job-bg.png';
import social from '@/assets/join/social.png';
import campus from '@/assets/join/campus.png';
import cardFooter from '@/assets/join/footer.png';

export const HERO = {
  title: '加入我们',
  subtitle: '投身AI · 重塑学习',
  image: heroBg,
};

export const RECRUIT = {
  title: '人才招聘',
  overlay: cardFooter,
  cards: [
    {
      image: social,
      labelEn: 'Social recruitment',
      label: '社会招聘',
      link: 'https://app.mokahr.com/social-recruitment/yuaiweiwu/145289?locale=zh-CN',
    },
    {
      image: campus,
      labelEn: 'Campus recruitment',
      label: '校园招聘',
      link: 'https://app.mokahr.com/campus-recruitment/yuaiweiwu/145290?locale=zh-CN',
    },
  ],
};

export const JOBS = {
  title: '热招岗位',
  image: jobBg,
  cards: [
    {
      title: 'AI 产品经理',
      tags: ['北京', '3-5年', '本科'],
      link: 'https://app.mokahr.com/m/social-recruitment/yuaiweiwu/145289?hash=%23%2Fjob%2Fb2043ee3-872b-4eae-a15e-81db7acefe96%3Ffrom%3Dqrcode',
    },
    {
      title: '模型语言学专家',
      tags: ['北京', '2-3年', '硕士'],
      link: 'https://app.mokahr.com/m/social-recruitment/yuaiweiwu/145289?hash=%23%2Fjob%2F124e75a1-223c-4650-8fc0-436ed27cbe1f%3Ffrom%3Dqrcode',
    },
    {
      title: '大模型算法工程师',
      tags: ['北京', '3-5年', '本科'],
      link: 'https://app.mokahr.com/m/social-recruitment/yuaiweiwu/145289?hash=%23%2Fjob%2Fd26a5a8f-cf85-4f9b-a274-178ea42d2352%3Ffrom%3Dqrcode',
    },
    {
      title: 'Agent 开发工程师',
      tags: ['北京', '3-5年', '本科'],
      link: 'https://app.mokahr.com/m/social-recruitment/yuaiweiwu/145289?hash=%23%2Fjob%2Fb998d741-4fbb-49d5-8726-f34a341c1d79%3Ffrom%3Dqrcode',
    },
  ],
};
